module.exports = "/packs/media/images/icons/house-d46602b2d1b55b852ecb8fac34a5df79.png";